import { render, staticRenderFns } from "./detalleLista.vue?vue&type=template&id=73f41cde&scoped=true&lang=html&"
import script from "./detalleLista.vue?vue&type=script&lang=js&"
export * from "./detalleLista.vue?vue&type=script&lang=js&"
import style0 from "./detalleLista.vue?vue&type=style&index=0&id=73f41cde&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f41cde",
  null
  
)

export default component.exports